module.exports = __webpack_public_path__ + "static/media/facebook.b9173756.svg";